import { Check, ShieldCheck } from "lucide-react";
import logoFull from "@/assets/tagforce-logo.png";
import logoWhite from "@/assets/tagforce-logo-white.png";

export const AuthSplitLayout = ({ testId, eyebrow = "TAGFORCE", statement, support, features = [], heading, description, children, footer }) => (
  <main className="login-split" data-testid={testId}>
    <aside className="login-brand-panel" aria-label="TAGForce">
      <div className="login-brand-pattern" aria-hidden="true" />
      <div className="login-brand-lockup" data-testid={`${testId}-brand-lockup`}>
        <img alt="TAGForce" className="login-brand-logo" src={logoWhite} />
        <span className="trademark">™</span>
      </div>
      <div className="login-brand-statement">
        <p className="login-brand-eyebrow" data-testid={`${testId}-eyebrow`}>{eyebrow}</p>
        <h1 data-testid={`${testId}-statement`}>{statement}</h1>
        {support && <p className="login-brand-support">{support}</p>}
        {features.length > 0 && (
          <ul className="login-brand-features" data-testid={`${testId}-features`}>
            {features.map((feature) => (
              <li key={feature}>
                <Check size={14} strokeWidth={2.5} aria-hidden="true" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      <p className="login-brand-footer">A product of The Allicock Group</p>
    </aside>
    <section className="login-form-panel">
      <div className="login-form-wrap">
        <img alt="TAGForce" className="login-form-logo" data-testid={`${testId}-form-logo`} src={logoFull} />
        <header className="login-form-heading">
          <h2 data-testid={`${testId}-heading`}>{heading}</h2>
          {description && <p>{description}</p>}
        </header>
        {children}
        {footer}
        <footer className="login-security-note">
          <ShieldCheck size={15} aria-hidden="true" />
          <span>Secure, authorized access only</span>
        </footer>
      </div>
    </section>
  </main>
);

export const AuthField = ({ id, label, icon: Icon, children, action }) => (
  <div className="login-field">
    {action ? (
      <div className="login-label-row">
        <label htmlFor={id}>{label}</label>
        {action}
      </div>
    ) : (
      <label htmlFor={id}>{label}</label>
    )}
    <div className="input-with-icon">
      {Icon && <Icon size={17} aria-hidden="true" />}
      {children}
    </div>
  </div>
);
